import { router } from '../../../app';
import { store } from '../../'

import ItemCreate from './ItemCreate'
import BoxCreate from './BoxCreate'
import ReceiptCreate from './ReceiptCreate'
const state = () => ({
    createIndex: 0,
    pageType:[
        {
            type: 'ItemListing',
            content:{
                name: 'ItemCreate',
                link: '/buy-tracker/item-create',
                displayName: 'Create An Item'
            }
        },
        {   
            type: 'ReceiptListing',
            content:{
                name: 'ReceiptCreate',
                link: '/buy-tracker/receipt-create',
                displayName: 'Create A Reciept'
                
            }
        },
        {
            type: 'BoxListing',
            content:{
                name: 'BoxCreate',
                link: '/buy-tracker/box-create',
                displayName: 'Create A Box'
            }
        }
    ],
    activePageType: {},
    tempItem:{}
});

const getters = {
    pageType: state => state.pageType,
    createIndex: state => state.createIndex,
    activePageType: state => state.pageType[state.createIndex],
    tempItem: state => state.tempItem
};

const mutations = {
    setActivePage(state, payload){
        state.pageType[state.createIndex].content.creationSteps[payload.oldActive].navigation.active = false;
        state.pageType[state.createIndex].content.creationSteps[payload.newActive].navigation.active = true;
    },
    setActiveType(state, index){
        state.createIndex = index;
    }
};

const actions = {
    /*({commit, state}, payload){
        var oldActive = state.pageType[state.createIndex].content.creationSteps.findIndex(x => x.navigation.active === true);
        commit('setActivePage', {'name': payload.pageName, 'oldActive': oldActive, 'newActive': payload.newActive});
    },
    changeActiveType({commit, state}, typeName){
        var thisIndex = state.pageType.findIndex(x => x.type === typeName)
        commit('setActiveType', thisIndex)
    }*/
};

const modules = {
    ItemCreate,
    BoxCreate,
    ReceiptCreate
};


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
    modules
}